
import TranResourcesApi from './src/Tranresources'


let apis = {
   TranResourcesApi
};

export default apis;
